/**
 * Client-side field rules that more than one surface enforces.
 *
 * A rule that lives in one page and is needed by a second gets moved here
 * rather than copied: two copies of a validator drift, and the one that drifts
 * is always the one the user meets.
 */

/**
 * The app-client display name, as `POST /apps` and `PUT /apps/{id}` accept it.
 *
 * Checked before the request so the answer arrives while the field still has
 * focus; the API enforces the same shape and remains the authority.
 */
export const validateAppName = (value: string): string | null => {
  const normalized = value.trim();
  if (!normalized) return 'App client name is required.';
  if (normalized.length > 128) return 'App client name must be 128 characters or fewer.';
  if (!/^[A-Za-z0-9][A-Za-z0-9 _-]*$/.test(normalized)) {
    return 'App client name can use letters, numbers, spaces, underscores, and hyphens.';
  }
  return null;
};
